/* eslint-disable react/prop-types */
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, ShadowCard } from '@/components';
import './game-shortcut.component.less';

const GameShortcutComponent = ({
    id,
    cardType,
    title,
    icon
}) => {
    const history = useHistory();
    function handleJumpDetail() {
        if (cardType === 'comingsoon') {
            return;
        }
        history.push(`/game/detail/${id}`);
    }

    if (cardType === 'comingsoon') {
        return (
            <div className="game-shortcut-component">
                <h2 className="title">{title}</h2>
            </div>
        );
    }
    return (
        <div
            className="game-shortcut-component"
        >
            <img className="icon" src={icon} alt="" />
            <h5 className="title">{title}</h5>
         
        </div>
    );
};

export default GameShortcutComponent;
